<template>
  <div class="filter-container">
    <button
      class="filter-btn"
      :title="'Show ' + displayName + ' filters'"
      @click.prevent="showFilters = true"
    />
    <div
      v-if="showFilters"
      class="filter-overlay"
      @click.self="showFilters = false"
    />
    <div
      v-if="showFilters"
      class="filters-dropdown filters"
    >
      <div class="filter-title">
        {{ displayName }} filters
      </div>
      <div
        class="filter-choice"
        v-for="(choice, index) in uniqueFilterChoices"
        :key="index"
      >
        <input
          type="checkbox"
          :id="fieldName + '_' + index"
          :class="fieldName"
          autocomplete="nope"
          :checked="selectedChoices.indexOf(choice.value) >= 0"
          @click="$emit('choiceSelected', fieldName, fieldName + '_' + index,  choice.value)"
        />
        <label :for="fieldName + '_' + index">
          {{ choice.display }}
        </label>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TableFilter',
  props: {
    displayName: {
      type: String,
      default: ''
    },
    fieldName: {
      type: String,
      required: true
    },
    filterChoices: {
      type: Array,
      default: () => []
    },
    selectedChoices: {
      type: Array,
      default: () => []
    }
  },
  emits: ['choiceSelected'],
  computed: {
    uniqueFilterChoices() {
      let uniqueFilters = []
      for (let i = 0; i < this.filterChoices.length; i++) {
        let filter = this.filterChoices[i]
        let filterAlreadyExists = false
        for (let j = 0; j < uniqueFilters.length && !filterAlreadyExists; j++) {
          let uniqueFilter = uniqueFilters[j]
          if (uniqueFilter.value === filter.value) {
            filterAlreadyExists = true
          }
        }
        if (!filterAlreadyExists) {
          uniqueFilters.push(filter)
        }
      }
      return uniqueFilters
    }
  },
  data() {
    return {
      selectAll: false,
      showFilters: false,
    }
  },
  mounted() {
    if (this.displayName === '') {
      this.displayName = this.fieldName
    }
  }
}
</script>

<style>
.filter-container {
  display: flex;
  align-items: baseline;
  font-size: 0.85em;
}
.filter-btn {
  background-image: url('/static/images/icons/funnel.svg');
  background-position: center;
  background-repeat: no-repeat;
  height: 24px;
  width: 24px;
}
.filters-dropdown {
  z-index: 20;
  position: absolute;
  background: #fff;
  border: 2px solid #ccc;
  font-weight: normal;
  transform: translateX(20px) translateY(20px);
  max-height: 20rem;
  max-width: 16rem;
  overflow-y: auto;
  overflow-x: hidden;
  text-wrap: wrap;
  word-break: break-all;
  box-shadow: 10px 10px 5px 0 rgba(0, 0, 0, 0.2);
}
.filter-choice, .filter-title {
  padding: 0.25rem 0.5rem 0.25rem 0.25rem;
}
.filter-title {
  text-transform: capitalize;
  font-weight: bold;
  border-bottom: 2px solid lightgrey;
  position: sticky;
  top: 0;
  background: #fff;
  z-index: 25;
  word-break: break-word;
  text-wrap: nowrap;

}
.filter-choice:nth-child(even) {
  background: #f5f5f4;
  & > label {
    text-overflow: ellipsis;
  }
}
.filter-overlay {
  position: fixed;
  top: 0;
  right: 0;
  width: 100vw;
  height: 100vh;
  z-index: 15;
}
</style>
